// @flow

import ConfigColor from './default';
import SmallColor from './small';

export {
  SmallColor,
};
export default ConfigColor;
